// import { ProgramSession, ProgramSessionCreateRequest, ProgramSessionSearchFilter, ProgramSessionSearchResponse } from '@api/entities';
import { ProgramSession, ProgramSessionCreateRequest, ProgramSessionSearchFilter, ProgramSessionSearchResponse, ProgramSessionUpdatDateRequest } from 'src/api/entities';
import { IWorkoutSessionApiService, WorkoutSessionApiService } from '../services/workoutSession/workout.session.api.client';


export interface IWorkoutSessionManager {
    search(page: number, size: number, query?: string, sort?: { [key: string]: string | undefined }, filter?: ProgramSessionSearchFilter): Promise<ProgramSessionSearchResponse>;
}

export class WorkoutSessionManager implements IWorkoutSessionManager {
    private static instance: WorkoutSessionManager;
    private workoutService: IWorkoutSessionApiService;

    private constructor() {
        this.workoutService = WorkoutSessionApiService.getInstance(process.env.REACT_APP_MICROSERVICE_AUTH_BASEPATH!);
    }

    static getInstance() {
        if (WorkoutSessionManager.instance == null) {
            WorkoutSessionManager.instance = new WorkoutSessionManager();
        }
        return WorkoutSessionManager.instance;
    }

    async searchCustomerSessions(customerID?: number): Promise<ProgramSessionSearchResponse> {

      const filter : ProgramSessionSearchFilter = {
        authorId: customerID
      }  
      
      const response: ProgramSessionSearchResponse = await this.workoutService.search(
          0, 
          100, 
          undefined, 
          undefined, 
          filter); 
        return response;
    }

    async search(customerID?: number, sessionID?: number): Promise<ProgramSessionSearchResponse> {

      const filter : ProgramSessionSearchFilter = {
        authorId: customerID,
        sessionID: sessionID
      }  
      
      const response: ProgramSessionSearchResponse = await this.workoutService.search(
          0, 
          100, 
          undefined, 
          undefined, 
          filter); 
        return response;
    }

    async create(request: ProgramSessionCreateRequest): Promise<ProgramSession> {
        const response = await this.workoutService.create(request);
        return response;
    }

    async duplicate(request: ProgramSessionCreateRequest): Promise<ProgramSession> {
        const response = await this.workoutService.duplicate(request);
        return response;
    }

    async getById(id: number): Promise<ProgramSession> {
        const response = await this.workoutService.getById(id);
        return response;
    }
    async updateDate(id: number, request: ProgramSessionUpdatDateRequest): Promise<ProgramSession> {
        const response = await this.workoutService.updateDate(id, request);
        return response;
    }
    async delete(id: number): Promise<{ [key: string]: boolean; }> {
        const response = await this.workoutService.delete(id);
        return response;
    }
}
